{
  "title": "Projects",
  "list_title": "Projects",
  "no_projects": "No projects yet",
  "select_or_new": "Select a project on the right or create a new one.",
  "search_placeholder": "Search or tag…",
  "webhook": {
    "label": "Webhook URL",
    "title": "Butler webhook",
    "description": "External services use it to fire this project's Butler flows (trigger “Webhook received”).",
    "url": "URL",
    "secret": "Secret",
    "secret_missing": "no secret set",
    "show": "Show",
    "hide": "Hide",
    "rotate": "Regenerate",
    "create": "Create secret",
    "rotate_confirm": "Generate a new secret? Calls with the old secret will be rejected immediately.",
    "rotate_failed": "The secret could not be regenerated.",
    "copy_failed": "Could not copy to the clipboard.",
    "header_hint": "Send it as the X-Webhook-Secret header with each call."
  },
  "tags": {
    "label": "Tags",
    "add_placeholder": "Add tag…"
  },
  "fields": {
    "members_count": "{{count}} members",
    "members_label": "Members ({{count}})",
    "git_init": "git",
    "git_init_no": "no-git",
    "agent": "Project agent",
    "workspace": "Workspace",
    "agent_loading": "(loading…)",
    "created_by": "{{date}} by {{user}}"
  },
  "delete_confirm": "Delete project \"{{name}}\"?\n\nIncludes project agent, workspace, and all sessions.",
  "members": {
    "no_members": "No members",
    "remove_confirm": "Remove '{{username}}' from project?",
    "select_user": "Select user…",
    "roles": {
      "read": "Read",
      "write": "Write",
      "admin": "Admin"
    }
  },
  "tabs": {
    "overview": "Overview",
    "notes": "Notes",
    "files": "Files",
    "sessions": "Sessions",
    "git": "Git",
    "servers": "Servers",
    "stats": "Stats",
    "settings": "Settings",
    "specialists": "Specialists",
    "audit": "History",
    "mounts": "Shares"
  },
  "specialists": {
    "description": "Which specialists can the project agent call via ask_agent?",
    "no_agentlink": "AgentLink is not configured — specialists cannot be called.",
    "none": "No specialists created yet.",
    "save": "Save",
    "saved": "Saved"
  },
  "notes": {
    "hint": "Markdown notes, briefing or context for this project.",
    "agent_hint": "Agents in project sessions receive the description and notes as a briefing (up to 4000 characters).",
    "placeholder": "# Project Briefing\n\nGoal, context, decisions…"
  },
  "files": {
    "empty": "Workspace is empty.",
    "close": "Close",
    "edit": "Edit",
    "save": "Save",
    "upload": "Upload",
    "delete": "Delete",
    "delete_confirm": "Really delete \"{{name}}\"?"
  },
  "overrides": {
    "title": "Tool restrictions",
    "mcp_label": "MCP servers (restriction)",
    "mcp_hint": "Empty = no restriction. Otherwise only these of the agents' MCP servers (comma-separated IDs). Never adds any.",
    "plugins_label": "Plugins (allowlist)",
    "plugins_hint": "Empty = no restriction. Otherwise only tools of these plugins are allowed (comma-separated names)."
  },
  "servers": {
    "empty": "No servers assigned yet.",
    "count_one": "{{count}} server",
    "count_other": "{{count}} servers",
    "add": "Assign server",
    "add_title": "Assign a VM or container",
    "none_available": "No free VMs / containers — create some under /vms or /containers first.",
    "unassign": "Remove from project",
    "unassign_confirm": "Remove server from project? (the server itself stays)",
    "open_detail": "Open details"
  },
  "sessions": {
    "empty": "No sessions in this project yet.",
    "untitled": "(untitled)"
  },
  "git": {
    "not_initialized": "No git repository in this workspace.",
    "recent_commits": "Recent commits",
    "no_remote": "No remote configured.",
    "no_repos": "No repos in this workspace yet.",
    "repos_count_one": "{{count}} repo",
    "repos_count_other": "{{count}} repos",
    "add_repo": "Add repo",
    "add_repo_title": "Add a new repo to this project",
    "repo_name": "Name (subfolder)",
    "repo_name_invalid": "Invalid — only a-z, 0-9, _ and -, max 50 chars, not \"_root\".",
    "remote_url": "Remote URL",
    "token": "Access token",
    "token_set": "set",
    "save_settings": "Save",
    "clone_url": "Repository URL",
    "branch_optional": "Branch (optional)",
    "init_empty": "Init empty",
    "clone": "Clone",
    "delete_confirm": "Remove repo \"{{name}}\" from this project? Including all local changes.",
    "delete_repo": "Remove repo",
    "danger_zone_hint": "This permanently deletes the local workspace contents.",
    "ahead": "ahead",
    "behind": "behind",
    "commit_message_placeholder": "Commit message…",
    "commit": "Commit",
    "push": "Push",
    "pull": "Pull"
  },
  "stats": {
    "unavailable": "Stats unavailable.",
    "sessions": "Sessions",
    "sessions_active": "{{count}} active",
    "messages": "Messages",
    "tokens": "Tokens",
    "last_activity": "Last activity"
  },
  "settings": {
    "danger_zone": "Danger zone — these actions cannot be undone.",
    "delete_project": "Delete project"
  },
  "samba": {
    "title": "SMB Share",
    "enable": "Enabled",
    "hint": "Login info: see System page → SMB Shares. Samba must be set up on the system.",
    "hint_inline": "Login is the same for all enabled projects. Samba must be set up on the system (see System page).",
    "user_label": "User",
    "password_label": "Password",
    "copy": "Copy",
    "copied": "Copied!"
  },
  "audit": {
    "empty": "No entries yet.",
    "load_error": "Could not load history.",
    "filter": {
      "all_actions": "All actions",
      "user_placeholder": "Filter by user…",
      "search": "Search"
    },
    "actions": {
      "project_updated": "Project updated",
      "member_added": "Member added",
      "member_removed": "Member removed",
      "server_assigned": "Server assigned",
      "server_unassigned": "Server unassigned",
      "member_role_changed": "Role changed"
    }
  },
  "new_dialog": {
    "title": "New project",
    "name_placeholder": "e.g. Website Relaunch",
    "model_label": "Model for project agent",
    "no_model": "(no model configured)",
    "git_init": "Initialize workspace with `git init`",
    "no_users": "(no users)"
  },
  "mounts": {
    "empty": "No share assigned yet.",
    "count_one": "{{count}} share",
    "count_other": "{{count}} shares",
    "add": "Assign share",
    "add_title": "Assign SMB share",
    "none_available": "No free shares — create a new one below.",
    "unassign": "Remove from project",
    "unassign_confirm": "Unmount and remove share from project? (definition is kept)",
    "create_title": "Create new SMB share",
    "create_submit": "Create",
    "f_name": "Name (e.g. nas-backup)",
    "f_host": "Host / IP (e.g. 192.168.178.219)",
    "f_share": "Share (e.g. backups)",
    "f_subpath": "Subpath (optional)",
    "f_credential": "Credential name (optional, empty = guest)",
    "f_readonly": "Read only",
    "credential_hint": "Auth via a 'basic' credential (user:password) under /credentials. Empty = guest access."
  }
}
